import { render } from "./fileNav.vue?vue&type=template&id=caa3a436&scoped=true"
import script from "./fileNav.vue?vue&type=script&lang=js"
export * from "./fileNav.vue?vue&type=script&lang=js"

import "./fileNav.vue?vue&type=style&index=0&id=caa3a436&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa3a436"]])

export default __exports__